var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.5C0 18.1325 18.1325 0 40.5 0C62.8675 0 81 18.1325 81 40.5C81 62.8675 62.8675 81 40.5 81C18.1325 81 0 62.8675 0 40.5Z",
    fill: "#F06D0F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7066_53151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4994 28.4165C38.1095 28.4165 35.7733 29.1252 33.7862 30.4529C31.7991 31.7806 30.2504 33.6678 29.3358 35.8757C28.4213 38.0837 28.182 40.5132 28.6482 42.8572C29.1144 45.2011 30.2653 47.3542 31.9551 49.044C33.645 50.7339 35.7981 51.8848 38.142 52.351C40.486 52.8172 42.9155 52.5779 45.1234 51.6634C47.3314 50.7488 49.2185 49.2001 50.5463 47.213C51.874 45.2259 52.5827 42.8897 52.5827 40.4998C52.5827 38.913 52.2701 37.3418 51.6629 35.8757C51.0557 34.4097 50.1656 33.0777 49.0436 31.9556C47.9215 30.8336 46.5895 29.9435 45.1234 29.3363C43.6574 28.729 42.0862 28.4165 40.4994 28.4165V28.4165ZM39.291 33.854C39.291 33.5335 39.4183 33.2262 39.6449 32.9996C39.8715 32.773 40.1789 32.6457 40.4994 32.6457C40.8198 32.6457 41.1272 32.773 41.3538 32.9996C41.5804 33.2262 41.7077 33.5335 41.7077 33.854V41.104C41.7077 41.4245 41.5804 41.7318 41.3538 41.9584C41.1272 42.185 40.8198 42.3123 40.4994 42.3123C40.1789 42.3123 39.8715 42.185 39.6449 41.9584C39.4183 41.7318 39.291 41.4245 39.291 41.104V33.854ZM40.4994 48.354C40.1409 48.354 39.7904 48.2477 39.4924 48.0485C39.1943 47.8494 38.962 47.5663 38.8248 47.2351C38.6876 46.9039 38.6517 46.5395 38.7217 46.1879C38.7916 45.8363 38.9642 45.5134 39.2177 45.2599C39.4712 45.0064 39.7942 44.8338 40.1458 44.7638C40.4973 44.6939 40.8618 44.7298 41.193 44.867C41.5242 45.0042 41.8072 45.2365 42.0064 45.5345C42.2056 45.8326 42.3119 46.183 42.3119 46.5415C42.3119 47.0222 42.1209 47.4832 41.781 47.8231C41.4411 48.163 40.9801 48.354 40.4994 48.354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7066_53151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29.0001,
    fill: "white",
    transform: "translate(26 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconNew);
export default __webpack_public_path__ + "static/media/errorIcon-new.b50d14580691e57a725004f5a379370e.svg";
export { ForwardRef as ReactComponent };